import React, { useEffect, useState } from "react";
import axios from "axios";

const SocialShare = ({ data }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const accessToken = process.env.GATSBY_META_TOKEN;

    axios
      .get(
        `https://graph.instagram.com/v12.0/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${accessToken}`
      )
      .then((response) => {
        const fetchedPosts = response.data.data;
        const latestPosts = fetchedPosts.slice(0, 3);
        setPosts(latestPosts);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <section className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto my-10 lg:my-16 xl:p-0 p-5">
      <div>
        <h2 className="text-center text-teal text-2xl font-bold my-10">
          {data.SocialTitle}
        </h2>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-10">
          {posts?.map((item, index) => {
            return (
              <div key={index} className="mt-10">
                <a
                  href={`${item.permalink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>
                    <div>
                      {item.media_type === "VIDEO" ? (
                        <img
                          src={item.thumbnail_url}
                          alt={`Instagram video ${index}`}
                          className="h-[300px] w-full"
                          controls
                        />
                      ) : (
                        <img
                          src={item.media_url}
                          alt={`Instagram post ${index}`}
                          className="h-[300px] w-full"
                        />
                      )}
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SocialShare;
